import React from 'react';

export const IconAi = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="37" height="28" viewBox="0 0 37 28" fill="none">
      <g filter="url(#filter0_d_379_19250)">
        <rect
          x="5"
          y="3"
          width="27.2"
          height="17.75"
          rx="6"
          fill="url(#paint0_linear_379_19250)"
          stroke="white"
          stroke-width="2"
        />
        <path
          d="M16.1663 7.15071H13.158C11.8142 7.15071 10.7246 8.23456 10.7246 9.57132V11.5836L12.9421 10.2394V9.61086C12.9421 9.26184 13.2258 8.98031 13.576 8.98031H15.7476C16.0984 8.98031 16.3814 9.26252 16.3814 9.61086V14.1406C16.3814 14.4896 16.0977 14.7711 15.7476 14.7711H13.5362C12.6091 14.7711 12.7694 13.8134 13.0689 13.405L13.7069 13.7322C13.5684 12.9258 13.7939 11.4002 14.105 10.5052C12.2027 11.7963 10.7246 12.8236 10.7246 14.5168C10.7246 15.5714 11.5229 16.6 12.9442 16.6H16.1663C17.51 16.6 18.5996 15.5162 18.5996 14.1794V9.57064C18.5996 8.23388 17.51 7.15002 16.1663 7.15002V7.15071Z"
          fill="white"
        />
        <path
          d="M22.8795 7.58071H20.0267V8.6604H22.6199C22.8381 8.6604 23.0137 8.82614 23.0137 9.03213V9.67024H21.1139C20.2787 9.67024 19.6016 10.3095 19.6016 11.098V11.7254C19.6016 12.5139 20.2787 13.1532 21.1139 13.1532H24.3918V9.00727C24.3918 8.21882 23.7146 7.57953 22.8795 7.57953V7.58071ZM23.0124 12.0759H21.3734C21.1553 12.0759 20.9797 11.9101 20.9797 11.7041V11.1217C20.9797 10.9157 21.1553 10.7499 21.3734 10.7499H23.0124V12.077V12.0759Z"
          fill="white"
        />
        <path d="M26.76 7.58075H25.3818V13.1544H26.76V7.58075Z" fill="white" />
      </g>
      <defs>
        <filter
          id="filter0_d_379_19250"
          x="0.5"
          y="0.5"
          width="36.2002"
          height="26.75"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="1.75" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.49 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_379_19250" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_379_19250"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_379_19250"
          x1="9.5"
          y1="8.5"
          x2="26.0556"
          y2="21.4288"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF2A00" />
          <stop offset="1" stop-color="#002BFF" />
        </linearGradient>
      </defs>
    </svg>
  );
};
